import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import * as Servicer from "../index";
import {
    ServicerPrepareEditFormResponse
} from "../../../types/modules/servicer/response";
import {StoreContext} from "../../../store.context";

export const Edit: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { servicerStore: { edit }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();
    const params = useParams();

    const data: ServicerPrepareEditFormResponse = useLoaderData() as ServicerPrepareEditFormResponse;

    const onCancel = () => {
        navigate(`/servicer`)
    }

    return <Servicer.Form onSave={(values) => { return edit({...values, id: params.id}) }} onCancel={onCancel} preparedData={data} />
})